<template>
    <a-table class="stripped table-hover" :columns="columns" :data-source="data" :pagination="false"
        :row-selection="rowSelection">
        <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'action'">
                <div class="icon-field">
                    <button type="button" class="btn table_action_btn" @click="viewMore(record.key)"><i
                            class="ti ti-eye"></i>
                        View Details</button>
                </div>
            </template>
        </template>
    </a-table>

    <!-- Fixed Pagination -->
    <div class="pagination-container" v-if="data.length > 0">
        <a-pagination :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total"
            showSizeChanger :pageSizeOptions="pageSizeOptions" @change="handleTableChange" class="d-flex" />
    </div>

    <div ref="apiKey" class="modal fade" id="apiKey_model" tabindex="-1" role="dialog" aria-labelledby="leadLable"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl apiKey-model">
            <div class="modal-content">
                <div class="d-flex justify-content-between">
                    <h4 class=""></h4>
                    <div class="modal-header border-0 m-0 justify-content-end">
                        <button class="btn-close" id="close-btn" data-bs-dismiss="modal" aria-label="Close">
                            <i class="ti ti-x"></i>
                        </button>
                    </div>
                </div>
                <div class="modal-body confirm">
                    <div class="mb-2">
                        <div class="table-responsive api-clicks-detail-table">
                            <table class="table table-bordered align-top">
                                <thead>
                                    <tr>
                                        <th style="min-width: 12rem">URL</th>
                                        <th style="min-width: 11rem">Date and Time</th>
                                        <th style="min-width: 9rem">Lookup ref</th>
                                        <th>Third-party response</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(entry, idx) in detailRows" :key="idx + '-' + (entry.url || '')">
                                        <td class="small text-break">{{ entry.url }}</td>
                                        <td class="small text-nowrap">{{ entry.timestamp }}</td>
                                        <td class="small">{{ entry.refDisplay }}</td>
                                        <td>
                                            <template v-if="entry.thirdPartyFormatted">
                                                <button type="button" class="btn btn-sm btn-outline-secondary mb-1"
                                                    data-bs-toggle="collapse"
                                                    :data-bs-target="'#api-click-json-' + idx"
                                                    aria-expanded="false">
                                                    Toggle JSON
                                                </button>
                                                <div class="collapse" :id="'api-click-json-' + idx">
                                                    <pre class="api-click-json-pre small mb-0">{{ entry.thirdPartyFormatted }}</pre>
                                                </div>
                                            </template>
                                            <span v-else class="text-muted">—</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button class="btn btn-outline-secondary cancel-btn" @click="cancel_change">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {
    ref,
    reactive,
    computed
} from 'vue';
import apiClient from "@/axios";
import { Modal } from 'bootstrap';

function formatThirdPartyResponse(val) {
    if (val == null || val === '') {
        return null;
    }
    if (typeof val === 'string') {
        try {
            const parsed = JSON.parse(val);
            return JSON.stringify(parsed, null, 2);
        } catch {
            return val;
        }
    }
    try {
        return JSON.stringify(val, null, 2);
    } catch {
        return String(val);
    }
}

function displaySearchRef(ref) {
    if (ref == null || ref === '') {
        return '—';
    }
    return String(ref);
}

export default {
    props: {
        filters: Object,
    },
    setup(props, { expose }) {
        const columns = [{
            title: "Api Name",
            dataIndex: "api_name",
            key: "api_name",
            sorter: {
                compare: (a, b) => a.api_name.localeCompare(b.api_name)
            }
        },
        {
            title: "User name",
            dataIndex: "user_name",
            sorter: {
                compare: (a, b) => a.user_name.localeCompare(b.user_name)
            }
        },
        {
            title: "Lookup ref",
            dataIndex: "search_reference_summary",
            key: "search_reference_summary",
            ellipsis: true,
        },
        {
            title: "Date",
            dataIndex: "date",
            sorter: {
                compare: (a, b) => a.date.localeCompare(b.date)
            }
        },
        {
            title: "Total Clicks",
            dataIndex: "total_clicks",
            sorter: {
                compare: (a, b) => {
                    a = a.total_clicks;
                    b = b.total_clicks;
                    return a > b ? -1 : b > a ? 1 : 0;
                },
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            key: "action"
        },
        ];

        const pageSizeOptions = computed(() => {
            let options = [10]; // Default option
            if (pagination.value.total > 10) options.push(20);
            if (pagination.value.total > 20) options.push(50);
            if (pagination.value.total > 50) options.push(100);
            return options;
        });

        const data = ref([]);
        const allData = ref([])
        const detailRows = ref([])
        const pagination = ref({
            current: 1,
            pageSize: 10,
            total: 0
        });
        const rowSelection = reactive({
            onChange: () => { },
            onSelect: () => { },
            onSelectAll: () => { },
        });

        const fetchAPIClicks = async (page = 1, pageSize = 10) => {
            try {
                const params = {
                    page,
                    pageSize,
                    start_date: formateDate(props.filters?.date?.[0]),
                    end_date: formateDate(props.filters?.date?.[1]),
                    api_name: props.filters?.api_name,
                    user_id: props.filters?.user_id,
                };
                const refFilter = props.filters?.search_reference;
                if (refFilter != null && String(refFilter).trim() !== '') {
                    params.search_reference = String(refFilter).trim();
                }
                const response = await apiClient.get('/company/api-clicks', { params })
                if (response.data.status) {
                    allData.value = response.data.data.data;
                    data.value = response.data.data.data.map((api) => {
                        const summary = api.search_reference_summary;
                        const summaryDisplay =
                            summary != null && String(summary).trim() !== ''
                                ? String(summary).trim()
                                : '—';
                        return {
                            key: api.id,
                            api_name: api.api_name,
                            date: api.date,
                            total_clicks: api.total_clicks,
                            user_name: api.user_name,
                            search_reference_summary: summaryDisplay,
                        };
                    });
                    pagination.value.total = response.data.data.total;
                } else {
                    console.error("Failed to fetch users:", response);
                }
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };

        const handleTableChange = (current, pageSize) => {
            pagination.value.current = current;
            pagination.value.pageSize = pageSize;
            fetchAPIClicks(pagination.value.current, pagination.value.pageSize);
        };

        const viewMore = (id) => {
            const record = allData.value.find(item => item.id === id);
            if (!record) {
                return;
            }
            const stamps = record.click_timestamps || [];
            const refs = record.search_references;
            const responses = record.third_party_responses;

            detailRows.value = stamps.map((value, i) => {
                const refVal = Array.isArray(refs) ? refs[i] : undefined;
                const respVal = Array.isArray(responses) ? responses[i] : undefined;
                return {
                    url: value?.url,
                    timestamp: value?.timestamp,
                    refDisplay: displaySearchRef(refVal),
                    thirdPartyFormatted: formatThirdPartyResponse(respVal),
                };
            });
            const el = document.getElementById("apiKey_model");
            if (el) {
                const modal = new Modal(el);
                modal.show();
            }
        }

        const cancel_change = () => {
            document.getElementById("close-btn")?.click()
        }

        const formateDate = (dateString) => {
            let date
            if (!dateString) {
                date = new Date(props.date?.[0])
            } else {
                date = new Date(dateString);
            }
            if (isNaN(date.getTime())) {
                return null;
            }

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');

            const formattedDate = `${yyyy}-${mm}-${dd}`;
            return formattedDate;
        };

        expose({
            fetchAPIClicks,
            dataCount: data, // expose data
        });

        return {
            columns,
            data,
            pagination,
            rowSelection,
            fetchAPIClicks,
            handleTableChange,
            pageSizeOptions,
            viewMore,
            allData,
            detailRows,
            cancel_change
        };
    },
};
</script>
<style>
.apiKey-model {
    max-width: 1140px !important;
}

.api-clicks-detail-table {
    max-height: 70vh;
    overflow: auto;
}

.api-click-json-pre {
    max-height: 240px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-word;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    padding: 0.5rem;
}
</style>
